import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import React, { useEffect, useRef, useState } from "react";
import ContactForm from "../components/ContactForm";



const Contact = ({ setPopActive }) => {
    return (
        <>
            {/* <AwardsComponent /> */}
            <div className="min-h-screen w-full bg-white dark:bg-transparent relative z-10
    text-black">
                {/* <ContactSection1 /> */}
                {/* <ContactSection2 setPopActive={setPopActive} /> */}
                <ContactForm />
                {/* <NewForm /> */}

            </div >
        </>
    )
}

export default Contact